var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52925 10.4712C3.2689 10.2109 3.2689 9.78878 3.52925 9.52843L7.52925 5.52843C7.7896 5.26808 8.21171 5.26808 8.47206 5.52843L12.4721 9.52843C12.7324 9.78878 12.7324 10.2109 12.4721 10.4712C12.2117 10.7316 11.7896 10.7316 11.5292 10.4712L8.00065 6.94265L4.47206 10.4712C4.21171 10.7316 3.7896 10.7316 3.52925 10.4712Z",
    fill: "#F1F2F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.867c383b25665befdde313a1639cec53.svg";
export { ForwardRef as ReactComponent };